import { connect } from 'react-redux'
import { selectProvider } from '../reducers/questionsProviders'
import { startMatch, startBet, askQuestion, getQuestions } from '../reducers/actions'
import HostPage from '../components/HostPage'
import { getMatches } from '../reducers/matches';
import { getQuestionGame } from '../reducers/questionGame';

const QUESTIONS_PROVIDER = 'QUIZ_QUESTIONS_PROVIDER'

const mapStateToProps = (state, { socket }) => ({
    socket: socket,
    numPlayers: state.numPlayers,
    questionsProvider: selectProvider(state, QUESTIONS_PROVIDER)
})

const mapDispatchToProps = (dispatch, { socket }) => ({
    onMount: () => {dispatch(getMatches(socket));  dispatch(getQuestionGame(socket)); dispatch(getQuestions(socket,QUESTIONS_PROVIDER))},
    onStartClick: (match) => dispatch(startMatch(socket, match)),
    onBet: (game_id, question) => dispatch(startBet(socket, game_id , question)),
    onAsk: (game_id, question) => dispatch(askQuestion(socket,game_id,  question))
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(HostPage)



// WEBPACK FOOTER //
// ./src/containers/HostPage.js